<template>
  <div v-loading.fullscreen.lock="isLoading">
    <el-dialog title="修改密码" class="rowdialog" style="z-index:9999 !important;"
      width="500px" top="60px"
      :visible="visible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="!needResetPassword"
      :show-close="!needResetPassword"
      :before-close="handleClose"
    >
      <el-form ref="objectForm" :model="ruleForm" :rules="rules" label-width="130px" label-position="right" style="height:auto; min-height:180px;">
        <el-alert
          type="warning"
          close-text="知道了"
          style="margin-bottom: 15px"
          v-if="needResetPassword"
        >
          <template slot="title" style="margin-bottom: 15px">
            首次登录需要修改密码
          </template>
        </el-alert>
        <el-form-item label="旧密码: " prop="oldPassWord">
          <el-input placeholder="请输入旧密码" v-model="ruleForm.oldPassWord" type="password" size="small">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码: " prop="newPassWord">
          <el-input v-model="ruleForm.newPassWord" placeholder="请输入新的密码" type="password" size="small"></el-input>
        </el-form-item>
        <el-form-item label="确认密码: " prop="surePassWord">
          <el-input v-model="ruleForm.surePassWord" placeholder="请输入确认密码" type="password" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" v-if="!needResetPassword">取 消</el-button>
        <el-button type="primary" @click="submitHander">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'UpdatePasswordForm',
  data () {
    var validatePassWord = (rule, value, callback) => {
      if(this.ruleForm.newPassWord != value){
        callback(new Error('两次密码输入不一致'));
      }else{
        callback();
      }
    };
    return {
      isLoading: false,
      visible: false,
      ruleForm: {
        oldPassWord: '',
        newPassWord: '',
        surePassWord: '',
      },
      needResetPassword: false,
      rules: {
        oldPassWord: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { max: 15, message: '密码不能多于15个字符', trigger: 'blur' },
          { min: 6, message: '密码不能少于6位', trigger: 'blur' }
        ],
        newPassWord: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { max: 15, message: '密码不能多于15个字符', trigger: 'blur' },
          { min: 6, message: '密码不能少于6位', trigger: 'blur' }
        ],
        surePassWord: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { max: 15, message: '密码不能多于15个字符', trigger: 'blur' },
          { min: 6, message: '密码不能少于6位', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    if (this.$store.state.user.reset_password_number === 0) {
      if (this.$store.state.user.uid > 1) {
        this.visible = true
        this.needResetPassword = true
      }
    }
  },
  methods: {
    show() {
      this.visible = true
      this.ruleForm = {
        oldPassWord: '',
        newPassWord: '',
        surePassWord: ''
      }
      if (this.$refs["objectForm"] && this.$refs["objectForm"].resetFields) {
        this.$refs["objectForm"].resetFields()
      }
    },
    submitHander() {
      const that = this
      that.$refs['objectForm'].validate((valid) => {
        if (!valid) {
          return false
        }

        if (that.ruleForm.newPassWord != that.ruleForm.surePassWord) {
          this.$message({type: 'danger', message: '两次输入的密码不一致'})
          return false
        }

        let postData = {
          password: that.ruleForm.oldPassWord,
          new_password: that.ruleForm.newPassWord
        }
        that.isLoading = true

        this.request("admin/Password", "put", postData).then(
          (res) => {
            that.$message({ message: '修改成功，请重新登录', type: 'success' })
            that.$store.dispatch('user/logout')
            .then(() => {
              that.$router.push({ path: 'login' })
            })
            that.isLoading = false
          },
          (error) => {
            that.isLoading = false
          }
        )
      })
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>
<style scoped>
.title{ margin-bottom:20px; }
.el-form-item{ width:90%; }
.role-main-box td{
  border: none;
}
.role-main-box .el-table--group::after, .role-main-box .el-table--border::after, .role-main-box .el-table::before {
    content: '';
    position: absolute;
    background-color: #fff;
    z-index: 1;
}
.role-main-box .el-table .bg-row {
  background: #F2F6FC;
}
.role-main-box .functions .el-checkbox__label {
  font-weight: 600;
  font-size: 14px;
}

</style>
